/* import __COLOCATED_TEMPLATE__ from './jp-smirf-enrollment-form.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import JpSmirfService from '@dashboard/shared-ui/clients/jpsmirf';
import { OptInRequest } from '@square/dashboard-protos/models/squareup/jpsmirf/externalservice';
var EnrollmentSelection = /*#__PURE__*/function (EnrollmentSelection) {
  EnrollmentSelection["NONE"] = "NONE";
  EnrollmentSelection["ENROLL"] = "ENROLL";
  EnrollmentSelection["DO_NOT_ENROLL"] = "DO_NOT_ENROLL";
  return EnrollmentSelection;
}(EnrollmentSelection || {});
let JpSmirfEnrollmentFormComponent = (_class = class JpSmirfEnrollmentFormComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "EnrollmentSelection", EnrollmentSelection);
    // expose EnrollmentSelection to the hbs template
    _initializerDefineProperty(this, "marketToasts", _descriptor, this);
    _initializerDefineProperty(this, "i18n", _descriptor2, this);
    _initializerDefineProperty(this, "enrollmentSelection", _descriptor3, this);
    _initializerDefineProperty(this, "hasError", _descriptor4, this);
    _initializerDefineProperty(this, "isLoading", _descriptor5, this);
  }
  selectEnrollOption() {
    this.enrollmentSelection = EnrollmentSelection.ENROLL;
    this.hasError = false;
  }
  selectDontEnrollOption() {
    this.enrollmentSelection = EnrollmentSelection.DO_NOT_ENROLL;
    this.hasError = false;
  }
  async submit() {
    if (this.enrollmentSelection === EnrollmentSelection.NONE) {
      this.hasError = true;
      return;
    }
    this.isLoading = true;
    const isEligible = this.enrollmentSelection === EnrollmentSelection.ENROLL ? true : false;
    try {
      const response = await JpSmirfService.optIn(OptInRequest.create({
        isEligible
      }));
      this.args.onSubmit(response.success);
    } catch {
      this.marketToasts.critical(this.i18n.t('common.serverError'));
    }
    this.isLoading = false;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "enrollmentSelection", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return EnrollmentSelection.NONE;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "hasError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "selectEnrollOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectEnrollOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectDontEnrollOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectDontEnrollOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "submit"), _class.prototype)), _class);
export { JpSmirfEnrollmentFormComponent as default };